import styled from "styled-components";
import isEmpty from "lodash/isEmpty";
import { TextLink } from "@vds3/buttons";
import { Modal } from "@vds3/modals";
import { TileletCarousel } from "@vds3/tiles";

export const DivWrapper = styled.div`
	margin-top: 2rem;
	@media screen and (max-width: 500px) {
		display: none;
	}
	@media screen and (min-width: 1024px) {
		width: 962px;
	}
`;
export const TitleWrapper = styled.div`
	margin-top: 5px;
	@media screen and (max-width: 767px) {
		margin-top: 12px;
	}
`;
const MobileWrapper = styled.div`
	display: none;
	@media screen and (max-width: 500px) {
		display: block;
		[class^="OuterTileContainer-VDS"] {
			padding: 0px !important;
			background-color: transparent !important;
		}
	}
`;
export const ModalWrapper = styled(Modal)`
	@media screen and (max-width: 767px) {
		[class^="StyledFooter-VDS"] {
			position: fixed;
			bottom: 10px;
			width: 93%;
		}
	}
`;
export const TextLinkWrapper = styled(TextLink)`
	width: 165px;
	margin-right: 5px;
`;
export const MobileCarousel = ({ data }) => {
	return (
		<MobileWrapper>
			<TileletCarousel
				peek="standard"
				layout="1UP"
				gutter="24px"
				surface="light"
				paginationFill="light"
				paginationInset="12px"
				paginationDisplay=""
				aspectRatio="auto"
				data={data}
			/>
		</MobileWrapper>
	);
};

export const nextOpenAccordion = (planData, selectedDevices, editId) => {
	let accor = ["all", "all"];
	let assigned = false;
	if (!isEmpty(planData)) {
		Object.values(planData)
			.sort((a, b) => (a.order > b.order ? 1 : -1))
			.forEach((plan, i) => {
				plan?.devices?.forEach((device, index) => {
					if (editId) {
						assigned = true;
						if (editId === device?.packageId) {
							accor = [i, index];
						}
					}
					if (
						selectedDevices &&
						device?.packageId &&
						!selectedDevices?.[device?.packageId] &&
						!assigned
					) {
						assigned = true;
						accor = [i, index];
					}
				});
			});
	}
	return accor;
};

export const proccedToShoppingCart = (availableDevices, selectedDevices) => {
	if (
		availableDevices !== null &&
		availableDevices &&
		selectedDevices !== null &&
		selectedDevices
	) {
		const featuresAvailable = availableDevices?.filter(
			(data) =>
				data.features !== null && data.features && Object.keys(data.features).length
		);
		if (
			availableDevices?.length === Object.keys(selectedDevices || [])?.length &&
			featuresAvailable?.length === availableDevices?.length
		)
			return true;
	}
	return false;
};
export const payLoadForLaptop = (deviceTotal, plansSelected) => {
	let mapDevice = {};
	if (deviceTotal !== null && deviceTotal) {
		const { devices } = deviceTotal;
		if (devices !== null && devices && devices.length) {
			devices.map((device) => {
				mapDevice = {
					...mapDevice,
					[device.packageId]: {
						...plansSelected[device.packageId],
						features: [
							{
								featureCode: "66332",
								featureLevel: "L",
								featureType: "SFO",
								operation: "ADD",
								quantity: "1",
							},
						],
					},
				};
			});
		}
	}
	return mapDevice;
};
